import type { Contract } from "../types/contract";

function normalizeUuidToken(value: string | null | undefined): string | null {
  const t = (value ?? "").trim().toLowerCase();
  return t.length > 0 ? t : null;
}

/**
 * When an assigned `reviewerUserId` is present from GET generated-contracts, only that app user passes.
 * When there is no assigned reviewer (`undefined`, `null`, or empty), returns true (not blocked by reviewer
 * identity); callers typically combine with Legal Decision (Red) role for that case. The API may still
 * return 403 if inappropriate.
 */
export function canCurrentUserCompleteGeneratedContractReview(
  contract: Contract,
  currentUserId: string | null,
): boolean {
  const reviewer = normalizeUuidToken(contract.reviewerUserId);
  if (reviewer == null) {
    return true;
  }
  const user = normalizeUuidToken(currentUserId);
  if (user == null) {
    return false;
  }
  return user === reviewer;
}
